import { render, staticRenderFns } from "./SonsMergeCard.vue?vue&type=template&id=ac612118&scoped=true&"
import script from "./SonsMergeCard.vue?vue&type=script&lang=js&"
export * from "./SonsMergeCard.vue?vue&type=script&lang=js&"
import style0 from "./SonsMergeCard.vue?vue&type=style&index=0&id=ac612118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac612118",
  null
  
)

export default component.exports